import {
    EditOutlined,
    FilterOutlined,
    CalculatorOutlined,
    SwapOutlined,
    CopyOutlined,
    ScissorOutlined,
    MergeCellsOutlined,
    FontSizeOutlined,
    ClearOutlined,
    BgColorsOutlined,
    SortAscendingOutlined,
    DeleteOutlined,
} from '@ant-design/icons';

export const TRANSFORM_TYPES = [
    {
        type: 'RENAME_COLUMN',
        label: 'Rename Column',
        description: 'Rename one or more columns',
        icon: EditOutlined,
    },
    {
        type: 'FILTER_ROWS',
        label: 'Filter Rows',
        description: 'Filter rows based on conditions',
        icon: FilterOutlined,
    },
    {
        type: 'CALCULATE_FIELD',
        label: 'Calculate Field',
        description: 'Create calculated column with formula',
        icon: CalculatorOutlined,
    },
    {
        type: 'REPLACE_VALUES',
        label: 'Replace Values',
        description: 'Find and replace values in columns',
        icon: SwapOutlined,
    },
    {
        type: 'REMOVE_DUPLICATES',
        label: 'Remove Duplicates',
        description: 'Remove duplicate rows',
        icon: CopyOutlined,
    },
    {
        type: 'SPLIT_COLUMN',
        label: 'Split Column',
        description: 'Split column by delimiter',
        icon: ScissorOutlined,
    },
    {
        type: 'MERGE_COLUMNS',
        label: 'Merge Columns',
        description: 'Combine multiple columns',
        icon: MergeCellsOutlined,
    },
    {
        type: 'CONVERT_DATA_TYPE',
        label: 'Convert Data Type',
        description: 'Change column data type',
        icon: FontSizeOutlined,
    },
    {
        type: 'TRIM_CLEAN_TEXT',
        label: 'Trim/Clean Text',
        description: 'Remove whitespace and clean text',
        icon: ClearOutlined,
    },
    {
        type: 'FILL_MISSING_VALUES',
        label: 'Fill Missing Values',
        description: 'Fill NULL or empty values',
        icon: BgColorsOutlined,
    },
    {
        type: 'SORT_DATA',
        label: 'Sort Data',
        description: 'Sort rows by columns',
        icon: SortAscendingOutlined,
    },
    {
        type: 'REMOVE_COLUMN',
        label: 'Remove Column',
        description: 'Delete one or more columns',
        icon: DeleteOutlined,
    },
    {
        type: 'PIVOT_AGGREGATE',
        label: 'Pivot / Aggregate',
        description: 'Group rows and calculate summaries',
        icon: CalculatorOutlined,
    },
];
